import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { TooltipOrToast } from "@faire/retailer-visitor-shared/components/TooltipOrToast/TooltipOrToast";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import myTeamRoute from "@faire/web-api--source/routes/retailer/settings/my-team";
import React from "react";
import styled from "styled-components";
export var SubUserNoPermissionsTooltip = function(param) {
    var tooltipPosition = param.tooltipPosition, onClick = param.onClick, targetNode = param.targetNode, innerRef = param.innerRef, dataTestId = param.dataTestId, className = param.className;
    var strictLocalize = useStrictLocalization().strictLocalize;
    return /*#__PURE__*/ _jsx(StyledTooltipOrToast, {
        className: className,
        "data-test-id": dataTestId,
        position: tooltipPosition !== null && tooltipPosition !== void 0 ? tooltipPosition : "top",
        contents: [
            {
                body: strictLocalize({
                    id: "taxn/K",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "You do not have access to payment information. Contact your account owner to request a change in permission."
                        }
                    ]
                })
            }
        ],
        action: /*#__PURE__*/ _jsx(Button, {
            variant: "tertiary",
            tertiaryColor: Core.text.inverse,
            target: "_blank",
            linkTo: myTeamRoute(),
            onClick: onClick,
            innerRef: innerRef,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "tNnHvC",
                defaultMessage: [
                    {
                        type: 0,
                        value: "View team page"
                    }
                ]
            })
        }),
        targetNode: targetNode
    });
};
var StyledTooltipOrToast = styled(TooltipOrToast).withConfig({
    componentId: "sc-d929b08f-0"
})([
    "width:max-content;"
]);
